import { of as observableOf, Observable } from 'rxjs';

import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { ADMIN_ROLE, CAREAPP_SUPPORT_1, GLOBAL_ROLES } from '@careapp-group/core';
import { Store } from '@ngrx/store';

import * as actions from '../../store/actions/index';
import { isAppReady } from '../../store/reducers/index';
import { getAuthenticationState } from '../../store/auth/auth.selectors';
import { State } from '../../store/auth';

/**
 * Guards routes that should only be accessed by a Global Admin
 */
@Injectable()
export class GlobalAdminGuard  {
  private authenticated: Observable<State>;
  private refreshed: Observable<boolean>;
  constructor(private store: Store<any>) {
    this.authenticated = this.store.select(getAuthenticationState);
    this.refreshed = this.store.select(isAppReady);
  }
  public canActivate(): Observable<boolean> {
    return this.refreshed.pipe(
      filter((refreshed) => refreshed === true),
      withLatestFrom(this.authenticated),
      switchMap(([refreshed, auth]) => {
        if (
          auth.auth &&
          auth.auth.session &&
          auth.roles &&
          auth.roles.some((r) => GLOBAL_ROLES.includes(r))
        ) {
          return observableOf(true);
        }
        this.store.dispatch(actions.RequestAuthLogoutAction({}));
        return observableOf(false);
      })
    );
  }
}
